import { render, staticRenderFns } from "./WalletOpenButton.vue?vue&type=template&id=83094994&scoped=true"
import script from "./WalletOpenButton.vue?vue&type=script&lang=js"
export * from "./WalletOpenButton.vue?vue&type=script&lang=js"
import style0 from "./WalletOpenButton.vue?vue&type=style&index=0&id=83094994&prod&scoped=true&lang=css"
import style1 from "./WalletOpenButton.vue?vue&type=style&index=1&id=83094994&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83094994",
  null
  
)

export default component.exports